const initialOldExcel = {
  oldExcelPermissions: {},
  oldExcelLists: [],
  oldExcelCount: 0,
  changedOldExcelStatus: {},
  loadingOldExcel: false,
  errorsOldExcel: {},
};

const oldExcelReducer = (oldExcel = initialOldExcel, action) => {
  switch (action.type) {
    case "GET_OLD_EXCEL_DATA_PENDING":
    case "SAVE_OLD_EXCEL_PENDING":
    case "CLEAR_OLD_EXCEL_PENDING":
      return { ...oldExcel, loadingOldExcel: true };

    case "CLEAR_OLD_EXCEL_FULFILLED":
      return {
        ...oldExcel,
        loadingOldExcel: false,
        oldExcelLists: [],
        oldExcelCount: 0,
        errorsOldExcel: {},
      };

    case "GET_OLD_EXCEL_DATA_FULFILLED":
      return {
        ...oldExcel,
        loadingOldExcel: false,
        oldExcelLists: action.payload || [],
        oldExcelCount: action.count || 0,
        oldExcelPermissions: action.permissions || {},
        errorsOldExcel: {},
      };

    case "SAVE_OLD_EXCEL_FULFILLED":
      return {
        ...oldExcel,
        loadingOldExcel: false,
        changedOldExcelStatus: action.payload || {},
        errorsOldExcel: {},
      };

    case "RESET_OLD_EXCEL_STATUS":
      return {
        ...oldExcel,
        loadingOldExcel: false,
        changedOldExcelStatus: {},
        errorsOldExcel: {},
      };

    case "CLEAR_OLD_EXCEL_REJECTED":
      return { ...oldExcel, loadingOldExcel: false };

    case "GET_OLD_EXCEL_DATA_REJECTED":
    case "SAVE_OLD_EXCEL_REJECTED":
      return {
        ...oldExcel,
        loadingOldExcel: false,
        errorsOldExcel: action.payload || {},
        changedOldExcelStatus: {},
      };

    default:
      return oldExcel;
  }
};

export default oldExcelReducer;
